export default {
  ULTRA_HD  : '2160p',
  HIGH      : '1080p',
  DEFAULT   : '720p',
  LOW       : '480p',
  LOWEST    : '360p',
  THUMBNAIL : '224x126'
};
